import { conversionCopy } from "@/lib/conversionCopy";
import { useLanguage } from "@/lib/useLanguage";

const GuaranteeSection = () => {
  const { t: originalT, language } = useLanguage();
  const overrides: Record<string, string> = conversionCopy[language].homeText;
  const t = (key: string) => overrides[key] ?? originalT(key);

  return (
    <section className="bg-gradient-to-br from-primary to-[hsl(220,60%,18%)] py-8 lg:py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="text-5xl mb-6">🛡️</div>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-foreground mb-4">
          {t("guarantee.heading")}
        </h2>
        <p className="text-primary-foreground/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          {t("guarantee.text")}
        </p>
      </div>
    </section>
  );
};

export default GuaranteeSection;
